<template>
    <div class="modal fade action-sheet" :class="{'inset' : inset}" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" v-if="header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" :class="[contentFull ? 'p-0':'', contentHeight ? 'mh-100':'' ]">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type: String,
            required : true,
        },
        header:{
            type: Boolean,
            required : false,
            default: true
        },
        inset:{
            type: Boolean,
            required : false,
            default: true
        },
        contentFull: {
            type: Boolean,
            required : false,
            default: false
        },
        contentHeight: {
            type: Boolean,
            required : false,
            default: false
        }
    },
}
</script>